import React, { Component } from 'react';
import { telechargerFichier } from '../../App_Code/API';
import { toDate, toEuros } from '../../App_Code/Utils';
import { verificationLocationState } from '../CaptureErreurs';
import SelecteurDate from '../SelecteurDate';
import Tableau from '../Tableau';

const AlertePasDeLigne = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Aucune ligne de relevé.</h1>
    </div>
);

/* RELEVES DOCUMENTS */

const LigneDocuments = ({ DateEcr, Libelle, DocToken }) => (
    <tr>
        <th>{toDate(DateEcr, 'L')}</th>
        <td>{Libelle}</td>
        <td className="text-right">
            {DocToken && (
                <a target="_blank" href={telechargerFichier(DocToken)}>
                    <i className="fa fas fa-download mr-3" title="Télécharger le document" />
                </a>
            )}
        </td>
    </tr>
);

const TableauDocuments = ({ historique }) => {
    const Entete = (
        <tr>
            <th scope="col">Date</th>
            <th scope="col">Libellé</th>
            <th scope="col" className="text-right">
                Document
            </th>
        </tr>
    );

    const Lignes = historique.map((releve, i) => <LigneDocuments key={i} {...releve} />);

    return (
        <div className="table-responsive">
            <Tableau Entete={Entete} Lignes={Lignes} />
        </div>
    );
};

/* RELEVES EBICS */

const LigneEBICS = ({
    DateEcr, Operation, Libelle, NumEcriture, Debit, Credit,
}) => (
    <tr>
        <th>{toDate(DateEcr, 'L')}</th>
        <td>{Operation}</td>
        <td>{Libelle}</td>
        <td>{NumEcriture !== 0 && NumEcriture}</td>
        <td className="text-right">{toEuros(Debit)}</td>
        <td className="text-right">{toEuros(Credit)}</td>
    </tr>
);

const TableauEBICS = ({ historique }) => {
    const Entete = (
        <tr>
            <th scope="col">Date écriture</th>
            <th scope="col">Opération</th>
            <th scope="col">Libellé</th>
            <th scope="col">N° écriture</th>
            <th scope="col" className="text-right">
                Débit
            </th>
            <th scope="col" className="text-right">
                Crédit
            </th>
        </tr>
    );

    const Lignes = historique.map((releve, i) => <LigneEBICS key={i} {...releve} />);

    return (
        <div className="table-responsive">
            <Tableau Entete={Entete} Lignes={Lignes} />
        </div>
    );
};

class PageBanqueReleves extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateDebut: new Date(props.location.state.Banque.DateRappro),
            dateFin: new Date(),
        };
    }

    ChangementDateDebut = (dateDebut) => {
        if (dateDebut) {
            this.setState({
                dateDebut,
            });
        }
    };

    ChangementDateFin = (dateFin) => {
        if (dateFin) {
            this.setState({
                dateFin,
            });
        }
    };

    render() {
        const { dateDebut, dateFin } = this.state;
        const { Banque } = this.props.location.state;

        const tDateDebut = new Date(dateDebut).getTime();
        const tdateFin = new Date(dateFin).getTime();
        const fReleves = Banque.LsReleves.filter((ligne) => {
            const tDateEcr = new Date(ligne.DateEcr).getTime();
            return tDateEcr >= tDateDebut && tDateEcr <= tdateFin;
        });

        let fRelevesTries = fReleves.slice();
        fRelevesTries.sort((a,b) => new Date(a.DateEcr).getTime() - new Date(b.DateEcr).getTime());
        const SoldeDebut = fRelevesTries.length > 0 ? fRelevesTries[0].SoldeDebut : 0;
        const SoldeFin = fRelevesTries.length > 0 ? fRelevesTries[fRelevesTries.length - 1].SoldeFin : 0;

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between mb-2">
                    <span>
                        <SelecteurDate label="Du : " valeurDate={dateDebut} onDayChange={this.ChangementDateDebut} />
                        <SelecteurDate label=" Au : " valeurDate={dateFin} onDayChange={this.ChangementDateFin} />
                    </span>
                    {Banque.RelevesEBICS && (
                        <React.Fragment>
                            <span className="col-sm-2 col-form-label">
                                Solde début relevé : {toEuros(SoldeDebut, true)} €
                            </span>
                            <span className="col-sm-2 col-form-label">
                                Solde fin relevé : {toEuros(SoldeFin, true)} €
                            </span>
                        </React.Fragment>
                    )}
                </div>
                {fReleves.length === 0 ? (
                    <AlertePasDeLigne />
                ) : (
                    <div className="table-responsive">
                        {Banque.RelevesEBICS ? (
                            <TableauEBICS historique={fReleves} />
                        ) : (
                            <TableauDocuments historique={fReleves} />
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}
PageBanqueReleves.displayName = 'PageBanqueReleves';
PageBanqueReleves.requiredLocationState = [
    'Banque', // Banque interrogée
];

export default verificationLocationState(PageBanqueReleves);



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageBanqueReleves.js